import React, { useState } from "react";
import moment from "moment";
import { Modal } from "antd";
import { useAuth } from "../../utility/AuthContext";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, Link } from "react-router-dom";

import LoginComponent from "./LoginComponent";
import SignUpComponent from "./SignUpComponent";
import PointerArrow from "../PointerArrow";
import { useAppSelector } from "../../store/hooks";

const LoginModal: React.FC = () => {
  const { t } = useTranslation();
  const userState = useAppSelector((state: any) => state.user);
  const { showLoginModal, setShowLoginModal } = useAuth();
  const [isSignup, setIsSignup] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const handleClose = () => {
    setShowLoginModal(false);
    if (location.pathname === "/privacy" || location.pathname === "/terms")
      return;
    userState.is_provider ? navigate("/installation") : navigate("/");
  };

  return (
    <Modal
      centered
      className="login-modal"
      style={{ padding: "32px" }}
      open={showLoginModal}
      footer={null}
      closable={true}
      onCancel={handleClose}
    >
      <div className="logo-black" />
      <h2>{isSignup ? t("Let’s get started!") : t("Welcome back!")}</h2>
      <p style={{ color: "#888", fontSize: "13px", marginTop: "4px" }}>
        {t(
          "NeuroPlus is a cloud GPU computing platform for renting and managing GPU instances for AI and machine learning workloads.",
        )}
      </p>
      <div className="modal-overlay">
        <div className="modal login-modal">
          {isSignup ? <SignUpComponent /> : <LoginComponent />}
        </div>
        <div className="login-modal-bottom">
          <div>
            {isSignup ? (
              <>
                <span className="first-time-text">
                  <span className="text" onClick={() => setIsSignup(false)}>
                    {t("Already a user?")} &nbsp;
                    {t("Log In")}
                    <PointerArrow />
                  </span>
                </span>
              </>
            ) : (
              <>
                {/* 暫時將 Sign Up 拿掉 */}
                <span className="first-time-text">
                  {t("First time user?")} &nbsp;
                  <span
                    className="text"
                    onClick={() =>
                      window.open(
                        "https://forms.gle/fF2e4vvWfyLPysL87",
                        "_blank",
                      )
                    }
                  >
                    {t("Sign Up")}
                    <PointerArrow />
                  </span>
                </span>
              </>
            )}
          </div>
          <footer>
            <div className="privacy-terms">
              <Link
                to="/privacy"
                data-no-auth
                onClick={() => setShowLoginModal(false)}
                style={{ color: "#5575D9", fontSize: "12px" }}
              >
                {t("Privacy Policy")}
              </Link>
              &nbsp;&nbsp;
              <Link
                to="/terms"
                data-no-auth
                onClick={() => setShowLoginModal(false)}
                style={{ color: "#5575D9", fontSize: "12px" }}
              >
                {t("Terms of Service")}
              </Link>
            </div>
            <span>
              Copyright ©{moment().year()} NeuroPlus. All rights reserved.
            </span>
            <span></span>
          </footer>
        </div>
      </div>
    </Modal>
  );
};

export default LoginModal;
